import React from 'react';
import PropertyCard from './PropertyCard';
import './PropertyList.css';

const PropertyList = ({ properties, onSelect }) => {
    return (
        <div className="property-list">
            {properties.map(property => (
                <PropertyCard key={property.id} property={property} onSelect={onSelect} />
            ))}
        </div>
    );
};

export default PropertyList;